import React from 'react';
import { Table, Button } from 'antd';
import { post, roundNum } from '../../../../common/utils';
import style from './index.module.scss';

export default class RecordsTable extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            value: '',
            dataList: [],
        };

        /**
         * 防止组件卸载后继续 setState
         */
        this._isMounted = false;
    }

    componentDidMount() {

        this._isMounted = true;

        this.getDataList(this.props);

        console.log("props.addons", this.props.addons);
        console.log("props", this.props);
    }

    componentDidUpdate(prevProps) {

        /**
         * 只在关键字段变化时重新请求
         */
        const prevSampleName =
            prevProps.addons?.getValue?.("sample_name");

        const currentSampleName =
            this.props.addons?.getValue?.("sample_name");

        const prevDate =
            prevProps.addons?.getValue?.("date");

        const currentDate =
            this.props.addons?.getValue?.("date");

        if (
            prevSampleName !== currentSampleName
            ||
            prevDate !== currentDate
        ) {

            console.log('componentDidUpdate');

            this.getDataList(this.props);

        }
    }

    componentWillUnmount() {

        this._isMounted = false;

    }

    /**
     * 计算均值
     */
    calcAvgValues = () => {

        let Fe = 0;
        let Mn = 0;
        let H2O = 0;

        let Fe_num = 0;
        let Mn_num = 0;
        let H2O_num = 0;

        this.state.dataList.forEach(item => {

            /**
             * Fe
             */
            if (
                item['Fe'] !== undefined
                &&
                item['Fe'] !== null
                &&
                item['Fe'] !== ''
            ) {

                Fe += Number(item['Fe']);

                Fe_num += 1;
            }

            /**
             * Mn
             */
            if (
                item['Mn'] !== undefined
                &&
                item['Mn'] !== null
                &&
                item['Mn'] !== ''
            ) {

                Mn += Number(item['Mn']);

                Mn_num += 1;
            }

            /**
             * H2O
             */
            if (
                item['H2O'] !== undefined
                &&
                item['H2O'] !== null
                &&
                item['H2O'] !== ''
            ) {

                H2O += Number(item['H2O']);

                H2O_num += 1;
            }

        });

        const Fe_avg =
            Fe_num > 0
                ? roundNum(Fe / Fe_num, 2)
                : 0;

        const Mn_avg =
            Mn_num > 0
                ? roundNum(Mn / Mn_num, 2)
                : 0;

        const H2O_avg =
            H2O_num > 0
                ? roundNum(H2O / H2O_num, 2)
                : 0;

        const val_str = JSON.stringify({
            Fe: Fe_avg,
            Mn: Mn_avg,
            H2O: H2O_avg,
        });

        /**
         * 避免重复 onChange
         */
        if (val_str !== this.props.value) {

            this.props.onChange?.(val_str);

        }
    }

    /**
     * 获取数据
     */
    getDataList = (props) => {

        const sample_name =
            props.addons?.getValue?.("sample_name");

        if (!sample_name) {

            /**
             * 清空数据
             */
            if (this.state.dataList.length > 0) {

                this.setState({
                    dataList: [],
                });

            }

            return;
        }

        const date =
            props.addons?.getValue?.("date");

        if (!date) {

            /**
             * 清空数据
             */
            if (this.state.dataList.length > 0) {

                this.setState({
                    dataList: [],
                });

            }

            return;
        }

        post(
            process.env.REACT_APP_SERVER_PATH + 'api/form/get_list',
            {
                tpl_code: [
                    "HUAYAN_MENGKUANG_RUCHANG",
                    "HUAYAN_MENGKUANG_RUCHANG_SIMPLE"
                ],
                page: 1,
                page_size: 999,
                sample_name: sample_name
            }
        ).then(retData => {

            /**
             * 组件已经卸载
             */
            if (!this._isMounted) return;

            if (
                retData?.data
                &&
                retData?.data?.results
            ) {

                const dataList =
                    retData.data.results
                        .filter(item => {

                            let c_json = {};

                            /**
                             * 防止 JSON.parse 崩溃
                             */
                            try {

                                c_json =
                                    JSON.parse(item.content);

                            } catch (e) {

                                return false;

                            }

                            const _date =
                                c_json['date'];

                            /**
                             * 日期过滤
                             */
                            if (_date !== date) {

                                return false;

                            }

                            /**
                             * 过滤特殊字段
                             */
                            if (
                                c_json['SiO2'] !== undefined
                                &&
                                c_json['SiO2'] !== null
                            ) {
                                return false;
                            }

                            if (
                                c_json['CaO'] !== undefined
                                &&
                                c_json['CaO'] !== null
                            ) {
                                return false;
                            }

                            if (
                                c_json['MgO'] !== undefined
                                &&
                                c_json['MgO'] !== null
                            ) {
                                return false;
                            }

                            if (
                                c_json['Al2O3'] !== undefined
                                &&
                                c_json['Al2O3'] !== null
                            ) {
                                return false;
                            }

                            return true;

                        })
                        .map(item => {

                            let c_json = {};

                            try {

                                c_json =
                                    JSON.parse(item.content);

                            } catch (e) {

                                c_json = {};

                            }

                            return {
                                id: item.id,
                                date: c_json['date'],
                                Mn: c_json['Mn'],
                                Fe: c_json['Fe'],
                                H2O: c_json['H2O'],
                                remark: c_json['remark'],
                            };

                        });

                /**
                 * 避免重复 setState
                 */
                if (
                    JSON.stringify(dataList)
                    !== JSON.stringify(this.state.dataList)
                ) {

                    this.setState({
                        dataList,
                    });

                }
            }

        }).catch(err => {

            console.error(err);

        });
    }

    render() {

        const { dataList } = this.state;

        return (
            <div className={style['wrapper']}>

                <Table
                    dataSource={dataList}
                    pagination={false}
                    size="small"
                    rowKey="id"
                    columns={[
                        {
                            title: '时间',
                            key: 'date',
                            render: (text, item) => {
                                return item.date;
                            }
                        },
                        {
                            title: '水分（%）',
                            key: 'H2O',
                            dataIndex: 'H2O',
                        },
                        {
                            title: 'Mn（%）',
                            key: 'Mn',
                            dataIndex: 'Mn',
                        },
                        {
                            title: 'Fe（%）',
                            key: 'Fe',
                            dataIndex: 'Fe',
                        },
                        {
                            title: '备注',
                            key: 'remark',
                            dataIndex: 'remark',
                        }
                    ]}
                />

                <Button
                    style={{
                        marginTop: "20px"
                    }}
                    type="primary"
                    ghost
                    onClick={this.calcAvgValues}
                >
                    计算均值
                </Button>

            </div>
        );
    }
}